import { CAR_IMAGE_PATH } from '@/utils/env';

export function carImage(value) {
  if (value) {
    return `${CAR_IMAGE_PATH}${value}.jpg`;
  }
  return 'http://www.nikko.fj.cn/api/html/images/chargeImg.jpg';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/filters/car-image.ts